import React, { Suspense, useState } from 'react';
import { ReactComponent as Logo } from '../images/optilift-logo-dark.svg';
import { ReactComponent as ArrowLeft } from '../images/arrow-left.svg';
import { ReactComponent as ArrowRight } from '../images/arrow-right.svg';
import './OnboardingShell.scss';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/storeHooks';
import OnboardingSteps from './OnboardingSteps';
// import { DefaultView } from './default-view/DefaultView';
import UserService from '../services/user/user.service';
import { UserPreference } from '../services/user/user.service';

const OnboardingShell = () => {
  const assetGroups = useAppSelector((state) => state.signInDefaultView);

  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const totalSteps = 3;

  const handleNext = () => {
    if (step === totalSteps) {
      return;
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (step === 1) {
      return;
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const handleGoToDashboard = async () => {
    const params: UserPreference = {
      Property: 'DefaultPage',
      Group: 'Landing',
      Value: '',
    };

    const selectedAssetId = assetGroups?.selectedGroup?.assets.find((asset) => asset.isSelected)?.assetId;
    if (selectedAssetId) {
      params.Value = `{"PageType": "Asset", "Value" : "${assetGroups?.selectedGroup?.assetGroupName}|${selectedAssetId}"}`;
    } else if (assetGroups?.selectedGroup) {
      params.Value = `{"PageType": "Group", "Value" : "${assetGroups?.selectedGroup?.assetGroupName}"}`;
    } else {
      navigate('/');
    }

    await UserService.saveLandingPage(params).then(() => {
      navigate('/');
    });
  };

  const whatsNew =
    'Collect and store more data than ever.\nPrioritize your tasks with enhanced dashboards.\nEnjoy new intuitive workflows.';
  const beyondStatus =
    'Single-screen, side-by-side viewing.\nLink your card data with history graphs.\nEnhanced detailed analysis.';

  return (
    <div data-testid='onboarding-shell' className='onboarding-shell'>
      <div className='onboarding-shell-left'>
        <div className='onboarding-shell-left-container'>
          <div className='onboarding-shell-content'>
            <div className='onboarding-shell-header'>
              <div className='onboarding-shell-header-logo-container'>
                <Logo className='onboarding-shell-logo' height={50} />
                <span className='onboarding-shell-title'>OptiLift solutions</span>
              </div>
            </div>
            {/* {step == 1 && <DefaultView />} */}
            <div className='onboarding-shell-steps'>
              {step === 1 && (
                <OnboardingSteps
                  data-testid='onboarding-steps-description'
                  header='Data at your fingertips'
                  description={whatsNew}
                />
              )}
              {step === 2 && (
                <OnboardingSteps
                  data-testid='onboarding-steps-description'
                  header='Make informed, data-driven decisions'
                  description={beyondStatus}
                />
              )}
            </div>
            <div className='onboarding-shell-navigation-buttons'>
              <button
                analytics-id='onboarding-shell-back-btn'
                className={`onboarding-shell-back ${step === 1 ? 'hide' : ''}`}
                onClick={handleBack}
              >
                <ArrowLeft className={'arrowleft'} />
                Back
              </button>
              <button
                analytics-id='onboarding-shell-skip-btn'
                className={`onboarding-shell-skip ${step === 1 || step === totalSteps ? 'show' : ''}`}
                onClick={handleGoToDashboard}
              >
                Skip intro
              </button>
              <button
                analytics-id='onboarding-shell-continue-btn'
                className='onboarding-shell-continue'
                onClick={step === 2 ? handleGoToDashboard : handleNext}
              >
                {step === 4 ? 'Go to my dashboard' : 'Continue'}
                <ArrowRight />
              </button>
            </div>
          </div>
          <div className='onboarding-shell-footer'>© SLB {new Date().getFullYear()}</div>
        </div>
      </div>
      <div className='onboarding-shell-right'>
        <div className='onboarding-shell-right'>
          <div className='onboarding-shell-image' data-testid='whats-new'>
            {step <= 1 && (
              <Suspense fallback={<div />}>
                <img src='./onboarding1.jpg' alt='onboarding image' width='72%' loading='lazy' />
              </Suspense>
            )}
            {step === 2 && (
              <Suspense fallback={<div />}>
                <img src='./onboarding2.jpg' alt='onboarding image' width='72%' loading='lazy' />
              </Suspense>
            )}
          </div>
          {step === 2 && (
            <div>
              <p className='onboarding-shell-right-header'>Welcome to OptiLift, your digital</p>
              <p className='onboarding-shell-right-header'>production partner.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingShell;
